import { path, httpService } from '@commons';

///////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/estoque/entrada' };
// api-dfe agora só via central: o cliente é o schema da sessão (URL), não vai mais na query
const argsMonitoramento = { ...path, path: '/fiscal/monitoramento-nfe-compra' };
///////////////////////////////////////////////////////////////////////////////

export function findAllNotasCompras(dominio, dataInicial, dataFinal, where) {
    return httpService.get({ ...argsMonitoramento, args: `/notas?startDate=${dataInicial}&endDate=${dataFinal}${where}` });
}

export function getTotalNotas(dominio, dataInicial, dataFinal, where) {
    return httpService.get({ ...argsMonitoramento, args: `/totalNotas?startDate=${dataInicial}&endDate=${dataFinal}${where}` });
}

export function getXmlNfeApiDfe(id, chaveAcesso) {
  return httpService.getFile({ ...argsMonitoramento, args: `/download-xml/${id}` }, chaveAcesso + '.xml');
}

export function readXmlFile(notaEntradaApiDfe, naturezaOperacao, localEstoqueId, propriedade) {
    return httpService.post({ ...args, path: '/estoque/entrada/importarXmlApiDFe/' + naturezaOperacao.id + "/" + localEstoqueId + "/" + propriedade }, notaEntradaApiDfe);
}

export function visualizarDanfeXmlFile(idNota) {
    return httpService.getPdf({ ...args, path: `/estoque/entrada/gerarDanfeXmlApiDfe/${idNota}` });
}

export function downloadZip(payload) {
  const { emitente, mes, ano} = payload;
  return httpService.getBlob(
    {
      ...argsMonitoramento,
      args: `/download-zip?cpfCnpj=${emitente}&mes=${mes}&ano=${ano}`,
    },
    `nfe_${mes}_${ano}.zip`,
  );

}
